import { NamePrefixModifier, withInjectedProps } from 'Components/Core/InjectedPropsContext';
import { IWorksheetComponent } from 'Components/Worksheets/Core/types';
import { hasNonEmptyValue } from 'Lib/Any';
import { pipe } from 'Lib/Hooks/Selectors';
import { not } from 'ramda';
import { useSelector } from 'react-redux';
import SeparationSievingPageSection from './Separation/SeparationSievingPageSection';
import { PortionSievingPageSection } from './Sieving';

/**
 * Group of sections required to perform separation and sieve produced portions.
 * Recursive as separations are nested.
 *
 * Name prefix should be the path of the portion being separated
 */
let SeparationSectionGroup: React.FC<IWorksheetComponent> = ({ createWorksheetSelector, namePrefix }) => {
  const isLastSeparation = useSelector(
    pipe(
      createWorksheetSelector!('Separation.FinePortion.Subspecimen.Separation'),
      (nextSeparation) => hasNonEmptyValue(nextSeparation),
      not
    )
  );

  return (
    <>
      <NamePrefixModifier appendNamePrefix={'Separation.CoarsePortion'}>
        <PortionSievingPageSection />
      </NamePrefixModifier>
      <SeparationSievingPageSection />
      <NamePrefixModifier appendNamePrefix={'Separation.FinePortion'}>
        <NamePrefixModifier appendNamePrefix={'Subspecimen'}>
          {isLastSeparation ? <PortionSievingPageSection /> : <SeparationSectionGroup />}
        </NamePrefixModifier>
      </NamePrefixModifier>
    </>
  );
};

SeparationSectionGroup = withInjectedProps(SeparationSectionGroup);

export default SeparationSectionGroup;
export { SeparationSectionGroup };
